import ImgixClient from "@imgix/js-core";

import { getConfig } from "@components/Config";

import type { ImgixOptions } from "./types";

const FIT_CROP = "crop";
const IMGIX_DOMAIN = getConfig<string>("IMGIX_DOMAIN");
const S3_BUCKET_URL = getConfig<string>("S3_BUCKET_URL");

const getResizedImageUrl = (
  url: string,
  width?: number,
  height?: number,
  extraOptions: ImgixOptions = {},
): string => {
  const path = url.replace(S3_BUCKET_URL, "");
  const client = new ImgixClient({ domain: IMGIX_DOMAIN });

  const options: ImgixOptions = {
    fit: FIT_CROP,
    ...extraOptions,
  };

  const hasWidth = Boolean(width);

  if (hasWidth) {
    options.w = width;
  }

  const hasHeight = Boolean(height);

  if (hasHeight) {
    options.h = height;
  }

  const imageUrl = client.buildURL(path, options);

  return imageUrl;
};

export default getResizedImageUrl;
